/*
  Menu Option (item) component styles.
*/

import { createStyles, makeStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    divider: {
      backgroundColor: variables.colorV2.popupMenu.option.border.default,
      marginBottom: '.2rem',
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: '.2rem',
    },
    spinner: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.spacing(0.625, 0),

      '& > .MuiCircularProgress-root': {
        width: '2.4rem !important',
        height: '2.4rem !important',
        color: variables.color.semantic.neutral,
      },
    },
    paperChild: {
      // marginLeft: theme.spacing(1.5),
      padding: '.4rem 0', // theme.spacing(1),
      minWidth: '24rem',
      boxShadow: '0 0.4rem 1.6rem rgba(0, 0, 0, 0.2)',
      borderRadius: variables.borderRadius.md,
    },
    menuList: {
      padding: '0',
    },
    menuItem: {
      backgroundColor: 'transparent',
      border: '1px solid transparent',
      borderRadius: 0,
      color: variables.colorV2.popupMenu.option.text.default,
      cursor: 'pointer',
      display: 'flex',
      fontSize: variables.font.size.md,
      fontWeight: 500,
      justifyContent: 'space-between',
      marginBottom: '.1rem',
      minHeight: 'auto',
      padding: theme.spacing(1),
      paddingRight: theme.spacing(4),
      position: 'relative',
      '&.Mui-selected': {
        backgroundColor: variables.colorV2.popupMenu.option.background.active,
        border: `1px solid ${variables.colorV2.popupMenu.option.border.active}`,
        '& svg path': {
          stroke: variables.colorV2.popupMenu.option.icon.stroke.active,
        },
        '& > span': {
          color: variables.colorV2.popupMenu.option.text.active,
        },
        '&:hover': {
          backgroundColor: variables.colorV2.popupMenu.background.hover,
          border: `1px solid ${variables.colorV2.popupMenu.option.border.hover}`,
          '& > span': {
            color: variables.colorV2.popupMenu.option.text.hover,
          },
          '& svg path': {
            stroke: variables.colorV2.popupMenu.option.icon.stroke.hover,
          },
        },
      },
      '&.Mui-selected.no-background': {
        backgroundColor: variables.colorV2.popupMenu.option.background.active,
        '& > span': {
          color: variables.colorV2.popupMenu.option.text.active,
        },
        '&:hover': {
          backgroundColor: variables.colorV2.popupMenu.option.background.hover,
          '& > span': {
            color: variables.colorV2.popupMenu.option.text.active,
          },
          '& svg path': {
            color: variables.colorV2.popupMenu.option.text.active,
            stroke: variables.colorV2.popupMenu.option.icon.stroke.active,
          },
        },
      },
      '&.menu-item-with-loading': {
        backgroundColor: variables.colorV2.popupMenu.option.background.active,
      },
      '&.menu-item-with-loading span': {
        color: variables.colorV2.popupMenu.option.text.active,
      },
      '&.menu-item-with-loading:hover': {
        backgroundColor: variables.colorV2.popupMenu.option.background.hover,
      },
      '&:hover': {
        backgroundColor: variables.colorV2.popupMenu.option.background.hover,
        border: `1px solid ${variables.colorV2.popupMenu.option.border.hover}`,
        color: variables.colorV2.popupMenu.option.text.hover,
        '& > span': {
          color: variables.colorV2.popupMenu.option.text.hover,
        },
        '& svg path': {
          stroke: variables.colorV2.popupMenu.option.icon.stroke.hover,
        },
      },
      '& svg': {
        position: 'absolute',
        right: theme.spacing(1),
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
    menuItemTop: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    menuItemLabel: {
      '&&': {
        color: variables.colorV2.popupMenu.option.text.default,
        fontWeight: 500,
        width: '100%',

        '&.capitalized': {
          textTransform: 'capitalize',
        },
      },
      '.Mui-selected &': {
        color: variables.colorV2.popupMenu.option.text.active,
      },
    },
    subtitle: {
      marginTop: theme.spacing(0.25),
    },
    description: {
      marginLeft: theme.spacing(1.5),
    },
    iconColorless: {
      '& path': {
        stroke: `${variables.color.primary.mediumGray} !important`,
      },
    },
    subSelectionText: {
      color: variables.colorV2.popupMenu.option.text.secondary,
    },
  }),
);
